<!--
 * Path: src/features/browser/forms/SubHeader.vue
 * Task: Reusable component for form subheaders. Downgraded typography to text-h6 to fix hierarchy inversion.
-->
<template>
  <div class="text-h6 mt-6 mb-2 d-flex align-center text-high-emphasis font-weight-medium">
    {{ title }}
    <v-btn v-if="info" icon="mdi-information-outline" variant="text" size="small" class="ms-2" @click="$emit('click:info')">
      <v-tooltip activator="parent" location="top">{{ info }}</v-tooltip>
      <v-icon>mdi-information-outline</v-icon>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
export interface SubHeaderProps {
  title: string;
  info?: string;
}

const { title, info = '' } = defineProps<SubHeaderProps>();
defineEmits<{ (e: 'click:info'): void; }>();
</script>
